import React, { useMemo } from 'react';
import { If, Then, Else } from 'react-if';
import classNames from 'classnames';
import './styles.css';
import { ReactComponent as SectionLogo } from './SectionLogo.svg';
import { ReactComponent as ArrayIcon } from './ArrayIcon.svg';
import { useAuth } from '../../../../../hooks/useAuth';
import { getStripeConnectLink } from '../../../../../constants/stripe';

const PaymentSection = () => {
    const {
        currentUser: { email, stripeUserId, uid },
    } = useAuth();

    const oauthLink = useMemo(() => {
        return getStripeConnectLink(email, uid);
    }, [email, uid]);

    return (
        <>
            <div
                className={classNames('d-flex payment-settings__container align-items-center', {
                    'payment-settings__container--active': !stripeUserId,
                    'payment-settings__container--deactivated': !!stripeUserId,
                })}
            >
                <SectionLogo className="mx-3" />
                <span>Payment Settings</span>
            </div>
            <div className="px-4 payment-settings">
                <div className="payment-settings__connect-button d-flex align-items-center justify-content-center p-3">
                    <a href={oauthLink} className="mr-3">
                        <If condition={!stripeUserId}>
                            <Then>
                                <span className="payment-settings__header-text">
                                    Setup Stripe account
                                </span>
                            </Then>
                            <Else>
                                <span className="payment-settings__header-text">
                                    Re-setup Stripe account
                                </span>
                            </Else>
                        </If>
                    </a>
                    <ArrayIcon />
                </div>
            </div>
        </>
    );
};

PaymentSection.propTypes = {};

export default React.memo(PaymentSection);
